import { decorationBackgroundSVG, toRem } from "../../../../helpers/theme";

const style = ({ theme }) => ({
    borderRadius: toRem(15),
    boxShadow: theme.shadows.subtle,
    backgroundColor: theme.colors.userProfileHead.main.background,
    "& .userProfile_content": {
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        padding: toRem(20),
        [theme.breakpoints.up("md")]: {
            padding: toRem(50),
        },
        color: theme.colors.userProfileHead.main.content.color,
    },
    "& .userProfileContent_head": {
        display: "flex",
        flexDirection: "row",
        position: "relative",
        "&::after": {
            content: '""',
            position: "absolute",
            left: toRem(90),
            right: 0,
            top: toRem(40),
            display: "block",
            width: "100%",
            height: toRem(5),
            backgroundColor: "transparent",
            backgroundImage: decorationBackgroundSVG(theme.colors.separator.default),
            backgroundRepeat: "repeat-x",
            backgroundPosition: "0 0",
            backgroundSize: "contain",
            [theme.breakpoints.up("md")]: {
                left: toRem(8),
                top: "50%",
                width: "calc(100% + 42px)",
            },
        },
    },
    "& .userProfileContent_avatar": {
        [theme.breakpoints.up("md")]: {
            zIndex: theme.zIndex.over,
            paddingRight: toRem(20),
        },
    },
    "& .userProfileContent_btnWrapper": {
        zIndex: theme.zIndex.over,
        position: "absolute",
        right: 0,
        top: toRem(20),
        [theme.breakpoints.up("md")]: {
            top: `calc(50% - ${toRem(20)})`,
        },
    },
});

export default style;
